// Pictures held decoded in memory (design-batch walk 2026-10-30, N1).
//
// The Mystic's room unmounts while About is open. Back on ✕, a fresh <img>
// for the portrait could wait seconds behind the deck's and the lessons'
// pictures. A live, decoded Image for the same URL keeps the browser's
// in-memory copy, so the new <img> paints at once. Only the latest few are
// held.

const MAX = 6
const held = new Map()

/** Hold (and start decoding) the picture at `url`; the same Image each time. */
export function holdImage (url) {
  if (!url || typeof Image === 'undefined') return null
  let img = held.get(url)
  if (img) {
    held.delete(url)
    held.set(url, img)
    return img
  }
  try {
    img = new Image()
    img.decoding = 'async'
    img.src = url
  } catch (e) {
    return null
  }
  held.set(url, img)
  while (held.size > MAX) held.delete(held.keys().next().value)
  return img
}

/** The held Image for `url`, or null. */
export function heldImage (url) {
  return held.get(url) || null
}

/** Ready to paint: loaded (or failed) already, or once it decodes. */
export function whenDecoded (img) {
  if (!img) return Promise.resolve()
  if (img.complete && img.naturalWidth) return Promise.resolve()
  if (img.decode) return img.decode().catch(() => {})
  return new Promise((resolve) => { img.onload = resolve; img.onerror = resolve })
}

export function releaseAllHeld () {
  held.clear()
}
